<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>Contact Information</h2>
  </div>
</div>

<dx-popup class="popupHome"
          [width]="400"
          [height]="150"
          [showTitle]="true"
          title="Remove Home Phone"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="popupVisibleHome">
  <div class="row">
    <div class="col-sm-12">
      <p>
        Are you sure your want to remove this phone number?
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
    </div>
    <div class="col-sm-3">
      <button class="btn btn-danger" (click)="removePhoneByType('Home')">Remove</button>
    </div>
    <div class="col-sm-3">
      <button class="btn btn-default" (onClick)="popupVisibleHome = false">Cancel</button>
    </div>
  </div>
</dx-popup>

<dx-popup class="popupCell"
          [width]="400"
          [height]="150"
          [showTitle]="true"
          title="Remove Cell Phone"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="popupVisibleCell">
  <div class="row">
    <div class="col-sm-12">
      <p>
        Are you sure your want to remove this phone number?
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
    </div>
    <div class="col-sm-3">
      <button class="btn btn-danger" (click)="removePhoneByType('Cell')">Remove</button>
    </div>
    <div class="col-sm-3">
      <button class="btn btn-default" (onClick)="popupVisibleCell = false">Cancel</button>
    </div>
  </div>
</dx-popup>

<dx-popup class="popupBiz"
          [width]="400"
          [height]="150"
          [showTitle]="true"
          title="Remove Business Phone"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="popupVisibleBiz">
  <div class="row">
    <div class="col-sm-12">
      <p>
        Are you sure your want to remove this phone number?
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
    </div>
    <div class="col-sm-3">
      <button class="btn btn-danger" (click)="removePhoneByType('Business')">Remove</button>
    </div>
    <div class="col-sm-3">
      <button class="btn btn-default" (onClick)="popupVisibleBiz = false">Cancel</button>
    </div>
  </div>
</dx-popup>

<dx-popup class="popupEmail"
          [width]="375"
          [height]="150"
          [showTitle]="true"
          title="Remove Email"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="popupVisibleEamil">
  <div class="row">
    <div class="col-sm-12">
      <p>
        Are you sure your want to remove this email address?
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
    </div>
    <div class="col-sm-3">
      <button class="btn btn-danger" (click)="removeEmail()">Remove</button>
    </div>
    <div class="col-sm-3">
      <button class="btn btn-default" (onClick)="popupVisibleEamil = false">Cancel</button>
    </div>
  </div>
</dx-popup>

<div class="row row2">

  <div class="col-md-6">
    <div class="panel panel-card contact-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-phone payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Phone Numbers</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body contact-content">
          <div class="row">
            <div class="col-sm-12">
              <div class="contact-container">
                <div *ngIf="accountHomePhone !== '' && accountHomePhone !== null && !editHome" id="homePhone">
                  <span class="medium-text">{{accountHomePhone}}</span><small> Home</small>
                  <span *ngIf="alertPhoneNumber !== accountHomePhone" (click)="openHomePopUp()" class="remove-link">REMOVE</span>
                  <span *ngIf="alertPhoneNumber !== accountHomePhone" (click)="editHomePhone()" class="edit-link">EDIT</span>
                  <span *ngIf="alertPhoneNumber === accountHomePhone" class="remove-link"><i class="fas fa-lock" title="This phone number is subscribed to Alerts, to edit or remove this phone number you must first remove this phone number from receiving Alerts."></i></span>
                </div>
                <div *ngIf="editHome" class="row">
                  <div class="col-sm-6">
                    <input (change)="validateEditPhone($event.target.value, 'home')" name="editHomeNumber" class="form-control" type="text" id="editHomeNumber" maxlength="10" [(ngModel)]="editHomeNumber" />
                  </div>
                  <div class="col-sm-6">
                    <input *ngIf="!enableEditHomeBtn" type="button" class="btn btn-primary" value="Save" disabled="disabled" />
                    <input *ngIf="enableEditHomeBtn" (click)="editPhoneByType('Home')" type="button" class="btn btn-primary" value="Save" />
                    <input type="button" (click)="editHome = false" class="btn btn-default" value="Cancel" />
                  </div>
                </div>

                <div *ngIf="accountCellPhone !== '' && accountCellPhone !== null && !editCell" id="cellPhone">
                  <span class="medium-text">{{accountCellPhone}}</span><small> Cell</small>
                  <span *ngIf="alertPhoneNumber !== accountCellPhone" (click)="openCellPopUp()" class="remove-link">REMOVE</span>
                  <span *ngIf="alertPhoneNumber !== accountCellPhone" (click)="editCellPhone()" class="edit-link">EDIT</span>
                  <span *ngIf="alertPhoneNumber === accountCellPhone" class="remove-link"><i class="fas fa-lock" title="This phone number is subscribed to Alerts, to edit or remove this phone number you must first remove this phone number from receiving Alerts."></i></span>
                </div>
                <div *ngIf="editCell" class="row">
                  <div class="col-sm-6">
                    <input (change)="validateEditPhone($event.target.value, 'cell')" name="editCellNumber" class="form-control" type="text" id="editCellNumber" maxlength="10" [(ngModel)]="editCellNumber" />
                  </div>
                  <div class="col-sm-6">
                    <input *ngIf="!enableEditCellBtn" type="button" class="btn btn-primary" value="Save" disabled="disabled" />
                    <input *ngIf="enableEditCellBtn" (click)="editPhoneByType('Cell')" type="button" class="btn btn-primary" value="Save" />
                    <input type="button" (click)="editCell = false" class="btn btn-default" value="Cancel" />
                  </div>
                </div>

                <div *ngIf="accountBizPhone !== '' && accountBizPhone !== null && !editBiz" id="bizPhone">
                  <span class="medium-text">{{accountBizPhone}}</span><small> Business</small>
                  <span *ngIf="alertPhoneNumber !== accountBizPhone"  (click)="openBizPopUp()" class="remove-link">REMOVE</span>
                  <span *ngIf="alertPhoneNumber !== accountBizPhone"  (click)="editBizPhone()" class="edit-link">EDIT</span>
                  <span *ngIf="alertPhoneNumber === accountBizPhone" class="remove-link"><i class="fas fa-lock" title="This phone number is subscribed to Alerts, to edit or remove this phone number you must first remove this phone number from receiving Alerts."></i></span>
                </div>
                <div *ngIf="editBiz" class="row">
                  <div class="col-sm-6">
                    <input (change)="validateEditPhone($event.target.value, 'biz')" name="editBizNumber" class="form-control" type="text" id="editBizNumber" maxlength="10" [(ngModel)]="editBizNumber" />
                  </div>
                  <div class="col-sm-6">
                    <input *ngIf="!enableEditBizBtn" type="button" class="btn btn-primary" value="Save" disabled="disabled" />
                    <input *ngIf="enableEditBizBtn" (click)="editPhoneByType('Business')" type="button" class="btn btn-primary" value="Save" />
                    <input type="button" (click)="editBiz = false" class="btn btn-default" value="Cancel" />
                  </div>
                </div>

              </div>
            </div>
          </div>
          <br />
          <div *ngIf="canAddNewPhoneNumber" class="row">
            <div class="col-sm-12">
              <span (click)="addNewPhoneInput()" class="add-link"><i class="fas fa-plus"></i> Add new phone number</span>
            </div>
          </div>
          <div *ngIf="addNewPhone" class="row">
            <div class="col-sm-3">
              <select id="phoneNumberType" (change)="setPhoneType($event.target.value)" class="form-control" value="{{phoneNumberType}}">
                <option *ngFor="let phoneNumberType of phoneTypes" [value]="phoneNumberType">{{ phoneNumberType }}</option>
              </select>
            </div>
            <div class="col-sm-4">
              <input *ngIf="phoneNumberType === '' || phoneNumberType === undefined" class="form-control" type="tel" disabled="disabled" />
              <input (change)="validatePhone($event.target.value)" name="newPhoneNumber" *ngIf="phoneNumberType !== '' && phoneNumberType !== undefined" class="form-control" type="text" id="phoneNumberInput" maxlength="10" [(ngModel)]="newPhoneNumber" />
            </div>
            <div class="col-sm-5">
              <input *ngIf="!enableAddPhoneBtn"  type="button" class="btn btn-primary" value="Save" disabled="disabled" />
              <input *ngIf="enableAddPhoneBtn" type="button" (click)="saveNewPhoneNumber()" class="btn btn-primary" value="Save" />
              <input type="button" (click)="cancelAddNewPhoneInput()" class="btn btn-default" value="Cancel" />
            </div>
          </div>
          <div *ngIf="addNewPhone" class="row">
            <div class="col-sm-12">
              <small *ngIf="!enableAddPhoneBtn">Enter phone number with no spaces/hyphens/parenthesis. Example: 5555555555</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="col-md-6">
    <div class="panel panel-card contact-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-at payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Emails</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body contact-content">
          <div class="row" *ngIf="accountEmail !== '' && accountEmail !== null && !editEmail">
            <div class="col-sm-7">
              <span class="medium-text">{{accountEmail}}</span>
              <br />
              <small>Used for Password Reset, Communications, and Alerts (if subscribed)</small>
            </div>
            <div class="col-sm-5">
              <div class="contact-container">
                <!--<span *ngIf="alertEmailAddress !== accountEmail" (click)="openEamilPopUp()" class="remove-link">REMOVE</span>
                <span *ngIf="alertEmailAddress !== accountEmail" (click)="editEmail = true" class="edit-link">EDIT</span>
                <span *ngIf="alertEmailAddress === accountEmail" class="remove-link"><i class="fas fa-lock" title="This email address is subscribed to Alerts, to edit or remove this email address you must first remove this email address from receiving Alerts."></i></span>-->
              </div>
            </div>
          </div>
          <div *ngIf="editEmail" class="row">
            <div class="col-sm-6">
              <input (change)="validateEditEmail($event.target.value)" name="accountEmail" class="form-control" type="email" id="editEmailInput" [(ngModel)]="accountEmail" />
            </div>
            <div class="col-sm-6">
              <input *ngIf="!enableEditEmailBtn" type="button" value="Save" class="btn btn-primary" disabled="disabled" />
              <input *ngIf="enableEditEmailBtn" type="button" (click)="saveEditEmail()" class="btn btn-primary" value="Save" />
              <input type="button" (click)="editEmail = false" class="btn btn-default" value="Cancel" />
            </div>
          </div>
          <div *ngIf="canAddNewEmail" class="row">
            <div class="col-sm-12 margin-top-25">
              <span (click)="addNewEmailInput()" class="add-link"><i class="fas fa-plus"></i> Add new email address</span>
            </div>
          </div>
          <div *ngIf="addNewEmail" class="row">
            <div class="col-sm-6">
              <input (change)="validateEmail($event.target.value)" name="newEmail" class="form-control" type="email" id="emailInput" [(ngModel)]="newEmail" />
            </div>
            <div class="col-sm-6">
              <input *ngIf="!enableAddEmailBtn" type="button" value="Save" class="btn btn-primary" disabled="disabled" />
              <input *ngIf="enableAddEmailBtn" type="button" (click)="saveNewEmail()" class="btn btn-primary" value="Save" />
              <input type="button" (click)="cancelAddNewEmailInput()" class="btn btn-default" value="Cancel" />
            </div>
          </div>
          <div *ngIf="addNewEmail" class="row">
            <div class="col-sm-12">
              <small *ngIf="!enableAddEmailBtn">Be sure to enter email in correct email format. Example: emailaddress@domain.com</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="row row3">
  <div class="col-md-12">
    <div class="panel panel-card contact-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-envelope payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Mailing Address</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body contact-content">
          <div class="row">
            <div class="col-sm-10">
              <span>The address where you receive all paper billing and letters</span>
              <br />
              <br />
            </div>
            <div class="col-sm-2">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <span class="medium-text">{{accountStreetAddress}}</span>
              <br />
              <span class="medium-text">{{accountCityStateZip}}</span>
            </div>
          </div>
          <!--<div class="row">
            <div class="col-sm-10">
              <br />
              <input id="tempAddressInput" type="checkbox" /> <span for="tempAddressInput">Set up a Temporary Mailing Address for Bill Delivery</span>
            </div>
            <div class="col-sm-2">
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</div>





// WEBPACK FOOTER //
// ./src/app/contact-container/contact-container.component.html